import { t } from "@lingui/macro";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React from "react";

import ShowMore from "@/components/shared/ShowMore";
import { ProductDetailsFragment } from "@/saleor/api";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

interface ProductDetailTabsProps {
	product: ProductDetailsFragment;
	descriptionExpanded?: boolean;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

class ProductDetailTabs extends React.Component<ProductDetailTabsProps, { value: number }> {
	private showMoreRef: React.RefObject<ShowMore>;

	constructor(props: ProductDetailTabsProps) {
		super(props);
		this.state = {
			value: 0,
		};
		this.handleChange = this.handleChange.bind(this);
		this.expandDescription = this.expandDescription.bind(this);
		this.showMoreRef = React.createRef();
	}

	handleChange(event: React.SyntheticEvent, newValue: number) {
		this.setState({ value: newValue });
	}

	expandDescription(scrollIntoView?: boolean) {
		this.showMoreRef.current?.setExpanded();
		if (scrollIntoView) {
			setTimeout(() => {
				this.showMoreRef.current?.scrollIntoView();
			}, 0);
		}
	}

	render() {
		const { product, descriptionExpanded } = this.props;
		return (
			<Box sx={{ width: "100%" }} className="pt-8 px-8">
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tabs
						value={this.state.value}
						onChange={this.handleChange}
						aria-label="basic tabs example"
					>
						<Tab label={t`Description`} {...a11yProps(0)} />
						{/* <Tab label={t`Reviews`} {...a11yProps(1)} />
                    <Tab label={t`Policies`} {...a11yProps(2)} /> */}
					</Tabs>
				</Box>
				<TabPanel value={this.state.value} index={0}>
					{product.description && (
						<div className="text-base text-gray-700 space-y-6">
							<ShowMore
								ref={this.showMoreRef}
								jsonStringData={product.description}
								expandable
								expanded={descriptionExpanded}
							/>
						</div>
					)}
				</TabPanel>
				{/* <TabPanel value={value} index={1}>
                Reviews
            </TabPanel>
            <TabPanel value={value} index={2}>
                Policies
            </TabPanel> */}
			</Box>
		);
	}
}

export default ProductDetailTabs;
